import { createSlice } from "@reduxjs/toolkit";
import {      contractNote_singleThunk } from "./thunk";


export const initialState = {
  contractNote_singleData: [],
  contractNote_singleError: {
    code: null,
    message: '',
    data: null
  },
  contractNote_singleLoading: false,
  
  
};

const ContractNote_Single = createSlice({
  name: "ContractNote_Single",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(contractNote_singleThunk.pending, (state) => {
      state.contractNote_singleLoading = true ;
      state.contractNote_singleError = initialState.contractNote_singleError; 
  });
    builder.addCase(contractNote_singleThunk.fulfilled, (state, action) => {
        state.contractNote_singleData = action.payload.data;
        state.contractNote_singleLoading = false ;
    });
    builder.addCase(contractNote_singleThunk.rejected, (state, action) => {
      state.contractNote_singleError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.contractNote_singleLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = ContractNote_Single.actions

export default ContractNote_Single.reducer;